import {flatten as _flatten} from 'lodash';
import {Action as CommonAction} from '@gisatcz/ptr-state';
import Select from './Select';
import interferometryDataActions from './InterferometryData/actions';
import interferometryDataSelectors from './InterferometryData/selectors';

function selectArea(mapKey, layerKey) {
	return (dispatch, getState) => {
		dispatch(
			CommonAction.components.set(
				'visualizations',
				'riskAssessmentActiveSection',
				'zones'
			)
		);
		dispatch(
			CommonAction.selections.clearFeatureKeysFilter('riskAssessmentRoads')
		);

		dispatch(updateInterferometryMapSetView(mapKey, layerKey));
		dispatch(useInterferometryMapData());
	};
}

function selectRoad(mapKey, layerKey) {
	return (dispatch, getState) => {
		dispatch(
			CommonAction.components.set(
				'visualizations',
				'riskAssessmentActiveSection',
				'roads'
			)
		);
		dispatch(
			CommonAction.selections.clearFeatureKeysFilter('riskAssessmentZones')
		);

		dispatch(updateInterferometryMapSetView(mapKey, layerKey));
		dispatch(useInterferometryMapData());
	};
}

function updateInterferometryMapSetView(mapKey, layerKey) {
	return (dispatch, getState) => {
		// zoom point map to area bounding box
		// TODO just set center for now
		const feature = Select.specific.eo4sdDrrInsarVietnam20.getSelectedFeature(
			getState(),
			mapKey,
			layerKey
		);
		if (feature) {
			const center = {
				lat: (feature.bbox[1] + feature.bbox[3]) / 2,
				lon: (feature.bbox[0] + feature.bbox[2]) / 2,
			};
			dispatch(CommonAction.maps.updateSetView('interferometry', {center}));
		}
	};
}

function setRiskAssessmentMapCenterByInterferometryMapCenter() {
	return (dispatch, getState) => {
		const interferometryView = Select.maps.getMapSetView(
			getState(),
			'interferometry'
		);
		if (interferometryView?.center) {
			dispatch(
				CommonAction.maps.updateSetView('risk-assessment', {
					center: interferometryView.center,
				})
			);
		}
	};
}

function useInterferometryMapData() {
	return (dispatch, getState) => {
		const fidColumnName = Select.app.getLocalConfiguration(
			getState(),
			'data.interferometry.fidColumnName'
		);
		const configuration = Select.app.getLocalConfiguration(
			getState(),
			'data.interferometry.tracks'
		);
		const type = configuration.types.activeKey;
		const orbits = _flatten(
			configuration.orbits.activeKeys.map(
				activeKey => configuration.orbits.trackByKey[activeKey]
			)
		);

		dispatch(
			interferometryDataActions.ensureDataForMap(type, orbits, fidColumnName)
		)
			.then(() => {
				dispatch(refreshMapData(type, orbits));
			})
			.catch(err => {
				throw new Error(err);
			});
	};
}

function refreshMapData(type, orbits) {
	return (dispatch, getState) => {
		const state = getState();
		const features = interferometryDataSelectors.getAllFeaturesByTypeAndTrackKeys(
			state,
			type,
			orbits
		);

		dispatch(CommonAction.maps.setMapLayerOption('interferometry-small',
			'interferometry-points-small', 'features', features || []));
		dispatch(CommonAction.maps.setMapLayerOption('interferometry-big',
			'interferometry-points-big', 'features', features || []));
	};
}

function useInterferometryPointStatistics(featureKeys) {
	return (dispatch, getState) => {
		const state = getState();

		// expecting only one feature to be selected
		const selectedFeatureKey = featureKeys[0];

		// get featureData
		const fidColumnName = Select.app.getLocalConfiguration(
			getState(),
			'data.interferometry.fidColumnName'
		);
		const trackType = Select.app.getLocalConfiguration(
			state,
			'data.interferometry.tracks.types.activeKey'
		);
		const feature = interferometryDataSelectors.getFeatureByTypeAndFeatureKey(
			state,
			trackType,
			selectedFeatureKey
		);

		if (feature?.properties?.trackKey) {
			dispatch(
				interferometryDataActions.ensureDataForPointStatistics(
					trackType,
					feature.properties.trackKey,
					fidColumnName,
					selectedFeatureKey
				)
			);
		}
	};
}

function setActiveSelection(key) {
	return (dispatch, getState) => {
		const state = getState();

		if (key === 'riskAssessment') {
			const activeRiskAssessmentSection = Select.components.get(
				state,
				'visualizations',
				'riskAssessmentActiveSection'
			);
			if (activeRiskAssessmentSection === 'zones') {
				dispatch(CommonAction.selections.setActiveKey('riskAssessmentZones'));
			} else if (activeRiskAssessmentSection === 'roads') {
				dispatch(CommonAction.selections.setActiveKey('riskAssessmentRoads'));
			}

			dispatch(CommonAction.maps.setActiveMapKey('risk-assessment-big'));
		} else if (key === 'interferometry') {
			dispatch(CommonAction.selections.setActiveKey('interferometry'));
			dispatch(CommonAction.maps.setActiveMapKey('interferometry-big'));
		}
	};
}

export default {
	...CommonAction,
	specific: {
		interferometryData: interferometryDataActions,
		eo4sdDrrInsarVietnam20: {
			selectArea,
			selectRoad,
			setActiveSelection,
			setRiskAssessmentMapCenterByInterferometryMapCenter,
			useInterferometryMapData,
			useInterferometryPointStatistics,
		},
	},
};
